/**
 * @generated SignedSource<<5df967629d987a07af1f7b034ee8b10e>>
 * @relayHash cfdc8d83aaf78e53f31b2e46829f1db0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d20e54ccde5595dcf75e6a4048b2bfd01d66c0ce3eb0ec861fdabab93510ddfc

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type RealtimeUpdater_issueUpdatedSubscription$variables = {
  cloudId: string;
  projectId: string;
};
export type RealtimeUpdater_issueUpdatedSubscription$data = {
  readonly jira: {
    readonly onIssueUpdatedByProjectNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type RealtimeUpdater_issueUpdatedSubscription = {
  response: RealtimeUpdater_issueUpdatedSubscription$data;
  variables: RealtimeUpdater_issueUpdatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectId",
            "variableName": "projectId"
          }
        ],
        "concreteType": "JiraIssueUpdatedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueUpdatedByProjectNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "RealtimeUpdater_issueUpdatedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RealtimeUpdater_issueUpdatedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "d20e54ccde5595dcf75e6a4048b2bfd01d66c0ce3eb0ec861fdabab93510ddfc",
    "metadata": {},
    "name": "RealtimeUpdater_issueUpdatedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "61bf429e6647cbf9bcb096e742aec037";

export default node;
